// extracted by mini-css-extract-plugin
export default {"noAccess":"PortalNoAccess_noAccess__zpZ6x"};